import { Type } from '@angular/core';
import { Observable } from 'rxjs';
import { NimbusIcon } from '@nimbus-library/features/shared/directives/nimbus-icon.directive';

export enum MenuEntryType {
  UserPreferences = 'UserPreferences',
  Companion = 'Companion',
}

export interface MenuEntry {
  route: IMenuRouteInfo;
  icon: NimbusIcon;
  indicator?: IMenuIndicator;
  renderAs?: MenuEntryType;
  filters: Array<Type<IMenuFilter> | IFilterType | IMenuFilter>;
  subEntries?: Array<MenuEntry>;
  subClass?: string;
  connectedPaths?: IMenuRouteInfo[];
  /**
   * Optional stream of a custom image URL that should replace the default {@link icon} when it
   * emits a non-empty string (e.g. UI-profile per-page customization). The template falls back
   * to the default {@link icon} whenever this observable is absent or emits <code>null</code>.
   */
  customImageUrl$?: Observable<string | null>;
  /**
   * Optional stream of custom tooltip text that should replace the default translated tooltip
   * derived from {@link route}'s name. The template falls back to the default translation
   * whenever this observable is absent or emits <code>null</code>.
   */
  customTooltip$?: Observable<string | null>;
}

export interface IMenuIndicator {
  displayed$: Observable<boolean>;
  displayedCount$?: Observable<number>;
  icon?: NimbusIcon;
  class?: string;
}

export interface IMenuRouteInfo {
  name: string;
  path?: string;
}

export interface IMenuFilter<TOption = any> {
  validate$(option?: TOption): Observable<boolean>;
}

export interface IFilterType<TOption = any> {
  type: Type<IMenuFilter<TOption>>;
  option: TOption;
}
